import { z } from 'zod';

/**
 * What a run asks of a piece of equipment before it starts: its name, since
 * equipment has no id to pick. The server takes up to 120 characters.
 */
export const equipmentSchema = z.object({
  equipmentLabel: z
    .string()
    .trim()
    .min(1, 'Name what you are checking.')
    .max(120, 'Keep the name under 120 characters.'),
});

/**
 * A checklist that asks for a signature is signed, by name, before it goes.
 * The server refuses a report it asked to be signed without either.
 */
export const signSchema = z.object({
  signedName: z.string().trim().min(1, 'Add your name.'),
  signature: z.string().min(1, 'Sign the report before you send it.'),
});
